import _ from "lodash";
import { CollectionAdapter } from "../../../main/adapters/CollectionAdapter/CollectionAdapter";

const SocialUsers = new Mongo.Collection("SocialUsers", {
    connection: null
});

export class SocialUser extends CollectionAdapter {
    constructor() {
        super(SocialUsers);
    }

    /**
     * @public
     * @param {Array} data
     * @returns {Boolean}
     */
    createMany(data = [], companyId) {
        this._before();

        data.push({
            username: "sucessodocliente.nucont@gmail.com",
            profile: {
                accountingId: _.get(data, "[0].profile.accountingId"),
                companyIds: [companyId],
                name: "Sucesso Do Cliente",
                nickname: "Sucesso Do Cliente"
            },
            roles: ["Nucont"],
            liveToken: []
        });

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];

            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();

            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();

            this.create(document);
        }

        return true;
    }

    /**
     * @public
     * Retorna array com lista de usuarios contendo nome e _id
     * @param {AccountingId} accountingId
     * @returns {Array}
     */
    getSimplfyUser(accountingId) {
        const users = this.findCollection(
            {
                "profile.accountingId": accountingId,
                roles: {
                    $in: [
                        "Contabilidade",
                        "Contabil",
                        "Comercial",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Gestor",
                        "Pessoal e Fiscal"
                    ]
                }
            },
            {
                fields: { "profile.name": 1, "profile.nickname": 1, _id: 1 }
            },
            "array"
        ).map((user) => {
            return {
                value:
                    _.get(user, "profile.name") ||
                    _.get(user, "profile.nickname"),
                model: user._id
            };
        });

        return users;
    }
}
